export default function ToggleSwitch({ checked, onChange }) {
  return <button onClick={onChange} className={`h-7 w-12 rounded-full p-1 transition ${checked ? "bg-violet-600" : "bg-white/15"}`}><span className={`block h-5 w-5 rounded-full bg-white transition ${checked ? "translate-x-5" : ""}`} /></button>;
}
